<template>
  <div class="warp">
    <navBox :page="'Display'"></navBox>
    
    <div class="">

      <Secondary :bgImage="bgImage" :Cntitle="Cntitle" :Entitle="Entitle">
          <template>
            <div  class="custom-layout">

                <div class="paragraph text-indent">
                  「约剑」平台已构建击剑领域领先的数字化基建体系：服务网络覆盖全国31省，累计为200+场专业赛事提供全链路技术护航，构筑行业级赛事标准；平台合作认证赛事参与人数突破38000+人，市占率突破90%，持续领跑击剑赛事数字化赛道。
                </div>

                <div class="paragraph">
                  <div>合作案例：</div>
                  <div>《2025年“世承杯” 击剑精英大奖预选赛（预备站）》</div>
                  <div>《2025年黄埔区击剑公开赛》</div>
                  <div>《“体育未来之星”2024年温州市击剑积分排名赛第二站》</div>
                  <div>《“奔跑吧·少年”2024年长沙市青少年“快乐之星”U系列击剑比赛》</div>
                  <div>《2024年上海市击剑俱乐部联赛（第三站）》</div>
                  <div>《2024年粤港澳大湾区击剑比赛》</div>
                  <div>《2024年“世承杯” 击剑精英选拔赛（第一站）》</div>
                  <div>《2023年辽宁省青少年击剑冠军系列赛第二站》</div>
                  <div>《2024年“奔跑吧.少年”海南省青少年体育联赛暨海南省青少年击剑系列赛(琼海站)》</div>
                  <div>《添越杯·第二届西北击剑邀请赛》</div>
                  <div>《2025 年清湾杯击剑公开邀请赛（第一站）》</div>
                  <div>《2024年常州“奥冠孙伟杯”击剑大奖赛》</div>
                  <div>《2024年华侨华人国际击剑邀请赛》</div>
                  <div>《2024年广州市击剑选拔赛第三站》</div>
                  <div>《2024年黄埔区中小学生击剑锦标赛》</div>
                  <div>《2024年广州市“五一”击剑公开赛》</div>
                  <div>《2024年广东省“常青滕杯”击剑冠军赛（第二站）》</div>
                  <div>《2023年全汇航体育击剑大奖赛第一站》</div>
                  <div>（持续更新，敬请期待）</div>
                </div>

            </div>
        </template>
      </Secondary>

    </div>
  </div>
</template>

<script>
import NavBox from '@/components/navBox.vue';
import Secondary from '../components/secondary.vue';
export default {
  name: 'DisplayPage',
  components:{ Secondary, NavBox },
  data(){
    return{
      Entitle: "DISPLAY",
      Cntitle: "案例展示",
      bgImage:"https://img.fencerspage.com/upload/oss/club/contest/20250317/504367d7e263e40c3.jpg",
    }
  },

  
  methods:{
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$media_num: 1200px;  // 屏幕宽度


.warp {
  margin: 0 auto;
  width: 100vw;
}

.media_box{
  width: 100vw;
  height: 50vw;
  font-size: 0.88vw; //17

  @media only screen and (max-width: $media_num) {
    width: 1200px;
    height:600px;  // 0.5*width
  }
}

.custom-layout{
  font-size: 1.85em;
  letter-spacing: 0.03em;

  .text-indent{
    text-indent: 2em;
  }

  .paragraph{
    padding-bottom: 3em;
    line-height: 1.8em;
  }
}
</style>
